import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  IconButton,
  Button,
} from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
// import { RADIOTHERAPY_USERACCESS_JSON } from "../../../Utility/Constants";
import { ImagePaths } from "../../../Utility/ImagePaths";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import { localGetItem } from "../../../Utility/Services/CacheProviderService";

const RADIOTHERAPY_USERACCESS_JSON = []

const AddRole = () => {
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();

  const passedState = location.state || {};
  const module_access = Array.isArray(passedState.module_access) ? passedState.module_access : JSON.parse(JSON.stringify(RADIOTHERAPY_USERACCESS_JSON));
  const loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))
  const ModulesList = localGetItem("ModulesList") ? JSON.parse(localGetItem("ModulesList")) : [];
  const branchId = localGetItem("BranchId") ? +localGetItem("BranchId") : null;
  const module = ModulesList?.find((list) => list?.branch_id === branchId);
  const ModuleData = module?.data?.find((list) => (list?.moduels === "Radiotherapy")) || null;
  const [isloader, setisloader] = useState(false);
  const AccessList = Array.isArray(passedState.module_access) ? passedState.module_access : module_access
  AccessList[0].title = ModuleData?.label
  const [role, setRole] = useState({
    role_code: passedState.role_code || "",
    role_name: passedState.role_name || "",
    is_active: passedState.is_active ?? true,
    edit_id: passedState.edit_id || null,
    module_access: AccessList,
  });
  const [selectedModule, setSelectedModule] = useState(ModuleData?.label || "");
  const [message, setMessage] = useState({
    isErrorMsgText: "",
    successMsgText: "",
    isErrorMsg: false,
    successMsg: false,
  });

  const errorMessage = (msg) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: msg,
    });
  };

  const successMessage = (msg) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: msg,
    });
  };

  const msgClose = () => {
    setMessage({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    });
  };

  const handleUpdate = () => {
    if (!passedState?.edit_id) return;
    const loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))
    const ModulesList = localGetItem("ModulesList") ? JSON.parse(localGetItem("ModulesList")) : [];
    const branchId = localGetItem("BranchId") ? +localGetItem("BranchId") : null;
    const module = ModulesList?.find((list) => list?.branch_id === branchId);
    const ModuleData = module?.data?.find((list) => (list?.moduels === "Radiotherapy")) || null;
    const AccessList = role?.module_access
    AccessList[0].title = ModuleData?.label
    const data = {
      role_code: role?.role_code || "",
      role_name: role?.role_name || "",
      module_access: AccessList || [],
      is_active: role?.is_active ?? true,
      id: passedState.edit_id,
      is_therapist_role: role?.module_access[0]?.data?.find((item) => item?.title === "Therapist")?.viewAccess || false,
      user_linked_modules: [ModuleData]
    };
    setisloader(true)
    RestAPIService.updateWithOutId(
      data,
      Serviceurls.ROLE_MASTER_GET)
      .then((res) => {
        if (res.data.status === "success") {
          setRole({
            role_code: res?.data?.role_code || "",
            role_name: res?.data?.role_name || "",
            is_active: res?.data?.is_active ?? true,
            module_access: res?.data?.module_access?.length
              ? res.data.module_access
              : module_access,
            edit_id: passedState.edit_id,
          });

          successMessage("Role updated successfully!");
          history.push("/Settings/UserAccess/UserSettings/RoleMaster");
          setisloader(false)
        }
      })
      .catch((e) => {
        console.error("Failed to update role", e);
        errorMessage("Failed to update role");
      });
  };


  const handleRoleDetailsChange = (e) => {
    const { name, value } = e.target;
    setRole({ ...role, [name]: value });
  };

  const handleSave = () => {
    const { role_code, role_name, module_access } = role;
    const ModulesList = localGetItem("ModulesList") ? JSON.parse(localGetItem("ModulesList")) : [];
    const branchId = localGetItem("BranchId") ? +localGetItem("BranchId") : null;
    const module = ModulesList?.find((list) => list?.branch_id === branchId);
    const ModuleData = module?.data?.find((list) => (list?.moduels === "Radiotherapy")) || null;
    const AccessList = module_access
    AccessList[0].title = ModuleData?.label
    const apiPayload = {
      role_code,
      role_name,
      is_active: true,
      is_therapist_role: module_access[0]?.data?.find((item) => item?.title === "Therapist")?.viewAccess || false,
      user_linked_modules: [ModuleData],
      module_access: AccessList,
    };

    try {
      setisloader(true)
      RestAPIService.create(apiPayload, Serviceurls.ROLE_MASTER_GET)
        .then((response) => {
          if (response?.data?.status === "success") {
            successMessage(response?.data?.status);
            history.push("/Settings/UserAccess/UserSettings/RoleMaster");
            setisloader(false)
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message) {
            errorMessage(error?.response?.data?.message);
          }
        });
    } catch (error) {
      errorMessage(error.message);
    }
  };


  const updateModuleAccess = (callback) => {
    setRole((prevRole) => {
      const updatedModuleAccess = JSON.parse(JSON.stringify(prevRole.module_access));
      const module = updatedModuleAccess.find((mod) => mod.title === selectedModule);
      if (module) {
        callback(module.data);
      }
      return { ...prevRole, module_access: updatedModuleAccess };
    });
  };

  /** ================= LOGIC FUNCTIONS ================= **/
  const handleSelectAllSubmodule = (submoduleTitle, checked) => {
    updateModuleAccess((data) => {
      const main = data.find((item) => item.title === submoduleTitle);
      if (main) {
        main.viewAccess = checked;
        if (!checked) main.editAccess = false;
        main.main_tabs.forEach((mainTab) => {
          mainTab.viewAccess = checked;
          if (!checked) mainTab.editAccess = false;
          mainTab.sub_tabs?.forEach((subTabs) => {
            subTabs.viewAccess = checked;
            if (!checked) subTabs.editAccess = false;
          });
        });
      }
    });
  };

  const handlePermissionChange = (submoduleTitle, permissionTitle, checked) => {
    updateModuleAccess((data) => {
      const main = data.find((item) => item.title === submoduleTitle);
      if (main) {
        const mainTab = main.main_tabs.find((tab) => tab.title === permissionTitle);
        if (mainTab) {
          mainTab.viewAccess = checked;
          if (!checked) mainTab.editAccess = false;
          mainTab.sub_tabs?.forEach((subTabs) => {
            subTabs.viewAccess = checked;
            if (!checked) subTabs.editAccess = false;
          });
        }
        if (main.main_tabs.every((item) => !item.viewAccess)) {
          main.viewAccess = false;
          main.editAccess = false;
        }
      }
    });
  };

  const handleSubPermissionChange = (submoduleTitle, permissionTitle, subPermissionTitle, checked) => {
    updateModuleAccess((data) => {
      const main = data.find((item) => item.title === submoduleTitle);
      if (main) {
        const mainTab = main.main_tabs.find((tab) => tab.title === permissionTitle);
        if (mainTab?.sub_tabs) {
          const subTab = mainTab.sub_tabs.find((tab) => tab.title === subPermissionTitle);
          if (subTab) {
            subTab.viewAccess = checked;
            if (!checked) subTab.editAccess = false;
          }
          if (mainTab.sub_tabs.every((item) => !item.viewAccess)) {
            mainTab.viewAccess = false;
            mainTab.editAccess = false;
          }
        }
      }
    });
  };

  const handleEditClick = (submoduleTitle, permissionTitle = null, subPermissionTitle = null) => {
    updateModuleAccess((data) => {
      const submodule = data.find((item) => item.title === submoduleTitle);
      if (!submodule) return;

      if (permissionTitle && subPermissionTitle) {
        const mainTab = submodule.main_tabs.find((tab) => tab.title === permissionTitle);
        const subTab = mainTab?.sub_tabs.find((tab) => tab.title === subPermissionTitle);
        if (subTab) {
          subTab.editAccess = !subTab.editAccess;
        }
      } else if (permissionTitle) {
        const mainTab = submodule.main_tabs.find((tab) => tab.title === permissionTitle);
        if (mainTab) {
          mainTab.editAccess = !mainTab.editAccess;
        }
      } else {
        submodule.editAccess = !submodule.editAccess;
        submodule.main_tabs.forEach((mainTab) => {
          mainTab.editAccess = submodule.editAccess && mainTab.viewAccess;
          mainTab.sub_tabs?.forEach((subTab) => {
            subTab.editAccess = submodule.editAccess && subTab.viewAccess;
          });
        });
      }
    });
  };

  const isEditEnabled = (submoduleTitle, permissionTitle, subPermissionTitle = null) => {
    const mainModule = role.module_access.find((mod) => mod.title === selectedModule);
    const submodule = mainModule?.data.find((mod) => mod.title === submoduleTitle);
    if (!submodule) return false;

    if (permissionTitle && subPermissionTitle) {
      const mainTab = submodule.main_tabs.find((tab) => tab.title === permissionTitle);
      return mainTab?.sub_tabs?.find((tab) => tab.title === subPermissionTitle)?.viewAccess || false;
    } else if (permissionTitle) {
      return submodule.main_tabs.find((tab) => tab.title === permissionTitle)?.viewAccess || false;
    }
    return submodule?.viewAccess || false;
  };

  return (
    <Box sx={{ padding: "3px", backgroundColor: "white", height: "80vh", display: "flex", flexDirection: "column" }}>
      {/* Header */}
      <Box sx={{ mb: 2, display: "flex", alignItems: "center" }}>
        <IconButton onClick={() => history.push("/Settings/UserAccess/UserSettings/RoleMaster")}>
          <img src={ImagePaths.arrowBack.default} />
        </IconButton>
        <Typography variant="h6" sx={{ margin: "1px" }}>
          {id ? "Edit Role" : "Add Role"}
        </Typography>
      </Box>

      <Grid container spacing={4} sx={{ flex: 1 }}>
        {/* Role Details Section */}
        <Grid item xs={12} md={4}>
          <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 1, p: 2, height: "100%" }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 2 }}>
              Role Details
            </Typography>
            <TextField fullWidth disabled label="Role Code" name="role_code" value={role.role_code} onChange={handleRoleDetailsChange} sx={{ mb: 2 }} />
            <TextField inputProps={{ maxLength: 100 }} fullWidth label="Role Name*" name="role_name" value={role.role_name} onChange={handleRoleDetailsChange} sx={{ mb: 2 }} />
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
              Module Access
            </Typography>
            <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 1, p: 1 }}>
              <FormControlLabel control={<Checkbox checked disabled />} label={selectedModule || ""} />
            </Box>
          </Box>
        </Grid>

        {/* Module Access & Permissions Section */}
        <Grid item xs={12} md={8}>
          <Box sx={{ border: "1px solid #e0e0e0", borderRadius: 1, p: 2, height: "33.5vw", overflowY: "auto" }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 2 }}>
              Module Access
            </Typography>

            <List sx={{ width: "100%" }}>
              {role.module_access[0]?.data?.map((submodule) => (
                <div key={submodule.title}>
                  <ListItem disablePadding sx={{ borderBottom: "1px solid #e0e0e0" }}>
                    <ListItemIcon>
                      <Typography variant="h6">
                        <img src={ImagePaths.arrowDropDown.default} />
                      </Typography>
                    </ListItemIcon>
                    <FormControlLabel
                      sx={{ width: "59vw" }}
                      control={
                        <Checkbox
                          checked={submodule.viewAccess}
                          onChange={(e) => handleSelectAllSubmodule(submodule.title, e.target.checked)}
                        />
                      }
                      label={submodule.title}
                    />
                    <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                      <IconButton
                        disabled={!isEditEnabled(submodule.title)}
                        sx={{ width: "1vw", display: "flex", justifyContent: "flex-end", fontSize: "small" }}
                        onClick={() => handleEditClick(submodule.title)}
                      >
                        <img
                          style={{ height: "1.2vw", width: "1.2vw" }}
                          src={submodule.editAccess ? ImagePaths.UserEditOn.default : ImagePaths.UserEditOff.default}
                        />
                      </IconButton>
                    </Box>
                  </ListItem>

                  {/* main_tabs */}
                  <List component="div" disablePadding sx={{ ml: 6 }}>
                    {submodule.main_tabs.map((permission) => (
                      <div key={permission.title}>
                        <ListItem disablePadding sx={{ borderBottom: "1px solid #e0e0e0" }}>
                          <FormControlLabel
                            sx={{ width: "20vw" }}
                            control={
                              <Checkbox
                                disabled={!submodule.viewAccess}
                                checked={permission.viewAccess}
                                onChange={(e) => handlePermissionChange(submodule.title, permission.title, e.target.checked)}
                              />
                            }
                            label={permission.title}
                          />
                          <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                            <IconButton
                              sx={{ fontSize: "small" }}
                              disabled={!isEditEnabled(submodule.title, permission.title)}
                              onClick={() => handleEditClick(submodule.title, permission.title)}
                            >
                              <img
                                style={{ height: "1.2vw", width: "1.2vw" }}
                                src={permission.editAccess ? ImagePaths.UserEditOn.default : ImagePaths.UserEditOff.default}
                              />
                            </IconButton>
                          </Box>
                        </ListItem>

                        {/* sub_tabs */}
                        <List component="div" disablePadding sx={{ ml: 6 }}>
                          {permission?.sub_tabs?.map((subPermission) => (
                            <div key={subPermission.title}>
                              <ListItem disablePadding sx={{ borderBottom: "1px solid #e0e0e0" }}>
                                <FormControlLabel
                                  sx={{ width: "25vw" }}
                                  control={
                                    <Checkbox
                                      disabled={!permission.viewAccess}
                                      checked={subPermission?.viewAccess}
                                      onChange={(e) =>
                                        handleSubPermissionChange(submodule.title, permission.title, subPermission.title, e.target.checked)
                                      }
                                    />
                                  }
                                  label={subPermission.title}
                                />
                                <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                                  <IconButton
                                    sx={{ fontSize: "small", color: "text.secondary" }}
                                    disabled={!isEditEnabled(submodule.title, permission.title, subPermission.title)}
                                    onClick={() => handleEditClick(submodule.title, permission.title, subPermission.title)}
                                  >
                                    <img
                                      style={{ height: "1.2vw", width: "1.2vw" }}
                                      src={subPermission.editAccess ? ImagePaths.UserEditOn.default : ImagePaths.UserEditOff.default}
                                    />
                                  </IconButton>
                                </Box>
                              </ListItem>
                            </div>
                          ))}
                        </List>
                      </div>
                    ))}
                  </List>
                </div>
              ))}
            </List>
          </Box>
        </Grid>
      </Grid>

      {message.isErrorMsg && (
        <ToastMsg
          severity="error"
          msg={message.isErrorMsgText}
          msgPop={msgClose}
        />
      )}
      {message.successMsg && (
        <ToastMsg
          severity="success"
          msg={message.successMsgText}
          msgPop={msgClose}
        />
      )}

      {/* Save Button */}
      <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
        <Button size="small" sx={{ textTransform: 'capitalize', marginRight: "1dvw" }} variant="contained" onClick={() => {
          const ModulesList = localGetItem("ModulesList") ? JSON.parse(localGetItem("ModulesList")) : [];
          const branchId = localGetItem("BranchId") ? +localGetItem("BranchId") : null;
          const module = ModulesList?.find((list) => list?.branch_id === branchId);
          const ModuleData = module?.data?.find((list) => (list?.moduels === "Radiotherapy")) || null;
          let AccessList = JSON.parse(JSON.stringify(RADIOTHERAPY_USERACCESS_JSON))
          AccessList[0].title = ModuleData?.label
          setRole({ ...role, module_access: AccessList });
        }}>
          {"Reset"}
        </Button>
        <Button size="small" sx={{ textTransform: 'capitalize' }} variant="contained" onClick={() => {
          let isValidAccess = role?.module_access[0]?.data?.some((item) => item?.viewAccess)
          if (isValidAccess && role?.role_name) {
            role.edit_id ? handleUpdate() : handleSave()
          } else if (!role?.role_name) {
            errorMessage("Enter Role name");
          } else {
            errorMessage("Give access for atleast any one screen");
          }
        }}>
          {role.edit_id ? "Update Role" : "Add Role"}
        </Button>
        {console.log(role.module_access)}
      </Box>
    </Box>
  );
};

export default AddRole; 